import * as R from 'ramda'

const topTeachers = (schoolPerformance) => {
  return R.pipe(
    R.map(data => ({
      point: data.tempNumber1,
      label: data.firstName,
      subtitle: `${data.tempNumber2} scans`,
      point2: data.tempNumber2
    })),
    R.sort(R.descend(R.prop('point2'))),
    R.take(5)
  )(schoolPerformance.teachers || [])
}

const topStudents = (schoolPerformance) => {
  return R.pipe(
    R.pluck('leaderboard'),
    R.flatten,
    R.sort(R.descend(R.prop('totalPoints'))),
    R.map(data => ({
      label: data.studentName || R.take(10, data.studentID),
      point: data.totalPoints,
      subtitle: data.kelasName,
    })),
    R.take(5)
  )(schoolPerformance.kelasResult || [])
}

const topClasses = (schoolPerformance) => {
  return R.pipe(
    R.sort(R.descend(data => data.totalPoints)),
    R.map(data => ({
      ...(data || {}),
      avg: Math.round(data.totalPoints / data.studentCount),
      point: data.totalPoints,
      label: data.kelasName,
      subtitle: data.studentCount ? `${data.studentCount} students` : `Level ${data.level}`
    })),
    R.take(5)
  )(schoolPerformance.kelasResult || [])
}

const behaviours = (schoolPerformance) => {
  if (!schoolPerformance.schoolResult) {
    return []
  }
  const data = schoolPerformance.schoolResult.map(data => ({
    name: data.name,
    value: data.tempTotalPoints,
    color: data.colour,
    totalScan: data.tempTotalPoints / (data.points || 1)
  }))
  return R.pipe(
    R.sort(R.descend(R.prop('value'))),
    R.filter(data => data.value > 0)
  )(data)
}

const totalScans = (schoolPerformance) => {
  return R.pipe(
    R.pluck('totalScan'),
    R.sum
  )(behaviours(schoolPerformance))
}

const totalPoints = schoolPerformance => {
  return R.pipe(
    R.pluck('value'),
    R.sum
  )(behaviours(schoolPerformance))
}

const pointsByClass = schoolPerformance => {
  return R.pipe(
    R.groupBy(data => R.trim(data.level)),
    R.mapObjIndexed((children, key) => {
      return {
        name: `Tahun ${key}`,
        children: R.pipe(
          R.map(data => ({
            name: data.kelasName,
            value: data.totalPoints
          }))
        )(children),
      }
    }),
    R.values,
    children => ({
      name: "school name",
      children,
    }),
  )(schoolPerformance.kelasResult)
}

export default {
  topTeachers,
  topStudents,
  topClasses,
  behaviours,
  totalScans,
  totalPoints,
  pointsByClass,
}